import axios from 'axios';
import bus from './bus.js'
import qs from 'qs';
import { Message } from 'element-ui'

axios.interceptors.request.use(function (config) {
  let token = localStorage.getItem('adminToken');
  config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
  config.headers['Accept-Language'] = localStorage.getItem("language") == 'zh'
  ? 'zh_CN'
  : "zh_HK";
  if (token) {
    config.headers['token'] = token

  }
  return config
}, function (error) {
  return Promise.reject(error)
});

var get = function (url, date, callback) {

  axios.get(url, {
    params: date
  })

    .then(function (res) {

      var data = res.data;

      let RES = typeof data === 'object' ? data : JSON.parse(data);

      typeof callback === 'function' && callback(RES)

    })
};


var post = function (url, data, callback) {
  var d = qs.stringify(data)
  
  axios.post(url, d)

    .then(res =>{
      
      var data = res.data;

      let RES = typeof data === 'object' ? data : JSON.parse(data);

      if (!RES.success && RES.error_code == 502) {
        console.log(RES,'RES')
        var local = getUrl();
        if(localStorage.getItem('oem-home')){
          console.log('localStorage.getItem(oem-home)')
          let oem = localStorage.getItem("oem-home");
          oem = typeof oem == "string" ? JSON.parse(oem) : oem;
          window.location.href = local + '#' + '/login?tag='+oem.tag
        }else{
          window.location.href = local + '#' + '/login'
        }
        return;
      }else if(RES.success){
        console.log('ggg')
      }else{
        // Message({
        //   type: "warning",
        //   message: RES.message,
        // })
      }
      typeof callback === 'function' && callback(RES, res.headers)
    })
    .catch(error => {

      
    });
}

// let BASE_URL = ""
// let ws_URL = ""
// console.log(process.env.NODE_ENV,'环境')
// // 正式环境
// if (process.env.NODE_ENV === 'production') {
//   BASE_URL = "http://47.114.74.95:8193"
//   ws_URL = "47.114.74.95:8193";
// } else {
//   // 测试环境
//   BASE_URL = "http://120.24.43.72:8083"
//   ws_URL = "120.24.43.72:8083";
// }

 
//测试库
// const BASE_URL = "http://120.24.43.72:8083"
// const ws_URL = "ws://120.24.43.72:8083";

//正式库
// const BASE_URL = "http://47.114.74.95:8193"
// const ws_URL = "47.114.74.95:8193";

//正式库3.0
const BASE_URL = "https://fxfk.aiqiangua.com:8293"
const ws_URL = "wss://fxfk.aiqiangua.com:8293";


// const BASE_URL = "http://47.114.74.95:8293"
// const ws_URL = "47.114.74.95:8293";

//临时库
// const BASE_URL = "http://120.24.43.72:8084"
// const ws_URL = "120.24.43.72:8084";
// const ws_URLOne = "47.114.74.95:8082" ;

let getUrl = function () {
  return location.href.split('#')[0]
}

let getCookie = function (name) {

  var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");

  if (arr = document.cookie.match(reg)) {

    return unescape(arr[2]);
  } else {

    return null;
  }
}

axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';


export {
  get,
  post,
  BASE_URL,
  ws_URL,
  ws_URLOne,
  getUrl,
  getCookie
}



// WEBPACK FOOTER //
// ./src/libs/tool.js